import { X } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useDeleteTerminal } from "./mutations";
import { Input } from "@/components/ui/input";
import { useForm } from "react-hook-form";

const DeleteTerminalModal = ({
  onCancel,
  isLoading,
  terminal,
}: {
  onCancel: () => void;
  isLoading?: boolean;
  terminal: any;
}) => {
  const { mutate: deleteMerchant, isPending } = useDeleteTerminal();
  const form = useForm();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="min-w-[500px] rounded-lg bg-white px-8 pb-8 pt-4"
      >
        <div className="flex justify-end">
          <button className="hover:text-red-500" onClick={onCancel}>
            <X className="size-6" />
          </button>
        </div>

        <div className="flex flex-col items-center text-secondary-black">
          <h2 className="text-center text-xl font-semibold  text-text-500">
            Delete Terminal
          </h2>
          <p className="text-center">You cannot reverse this process</p>
          <Input
            placeholder="Type in the Terminal ID to confirm"
            className="mt-4"
            {...form.register("terminalId")}
          />
          <span className="self-start bg-slate-600 rounded text-white px-4 py-0.5 mt-1">
            {terminal.terminalId}
          </span>
          <Button
            disabled={
              isPending || form.watch("terminalId") !== terminal.terminalId
            }
            isLoading={isPending}
            onClick={() =>
              deleteMerchant(
                { id: terminal.terminalId },
                {
                  onSuccess: () => {
                    onCancel();
                  },
                }
              )
            }
            className="mt-4 w-full rounded-md bg-error-500 hover:bg-red-400 px-4 py-2 text-sm text-white disabled:cursor-not-allowed disabled:bg-red-200"
          >
            Yes, Proceed
          </Button>
          <button
            onClick={onCancel}
            className="mt-2.5 w-full rounded-md border border-error-500 px-4 py-2 text-sm text-error-500"
          >
            No, Cancel this Process
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DeleteTerminalModal;
